<template>
  <div>
    <ts-loading-banner :loading="student_search">
      <form>
        <fieldset>
          <legend>{{ $t('studentEnrollment.enroll') }}</legend>
          <div class="overflow-auto" id="enroll">
            <panel :title="$t('studentEnrollment.studentList')">
              <div id="student-table-container">
                <table
                  class="table table-hover ui-table ts-table"
                  id="student-table"
                >
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.cardNumber') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studentName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.sex') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.dob') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.phoneNumber') }}
                      </th>
                    </tr>
                    <tr>
                      <th colspan="5">
                        <input
                          type="text"
                          class="form-control"
                          :placeholder="$t('studentEnrollment.searchStudent')"
                          v-model="student_search_value"
                          :disabled="model.class_id == ''"
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(student, index) in studentLists"
                      :key="index"
                      @dblclick="selectStudent(student)"
                    >
                      <td class="ts-whitespace-no-wrap">
                        {{ student.card_number ? student.card_number : null }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.full_name_en }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.gender }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ student.date_of_birth }}
                      </td>
                      <td class="ts-whitespace-no-wrap">{{ student.phone }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </panel>
            <panel :title="$t('studentEnrollment.enrollmentList')">
              <div class="overflow-auto">
                <table class="table table-hover ui-table ts-table mt-2">
                  <thead>
                    <tr>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.cardNumber') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.studentName') }}
                      </th>
                      <th class="ts-whitespace-no-wrap">
                        {{ $t('studentEnrollment.sex') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width:7%">
                        {{ $t('studentEnrollment.isMain') }}
                      </th>
                      <th
                        class="ts-whitespace-no-wrap text-center"
                        style="width:7%"
                      >
                        {{ $t('studentEnrollment.swap') }}
                      </th>
                      <th class="ts-whitespace-no-wrap" style="width:3%">
                        {{ $t('actions') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(list, index) in model.student_id_list"
                      :key="index"
                    >
                      <td class="ts-whitespace-no-wrap">
                        {{ studentFilter(list).card_number }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ studentFilter(list).full_name_en }}
                      </td>
                      <td class="ts-whitespace-no-wrap">
                        {{ studentFilter(list).gender }}
                      </td>
                      <td style="padding-top: 5px;">
                        <div class="checkbox checkbox-css">
                          <input
                            type="checkbox"
                            id="is_main"
                            v-model="list.is_main_class"
                          />
                          <label for="is_main"></label>
                        </div>
                      </td>
                      <td class="text-center">
                        <select
                          v-model.number="list.swap_type_id"
                          class="none-border"
                        >
                          <option value="0">{{
                            $t('studentEnrollment.fixed')
                          }}</option>
                          <option value="1">{{
                            $t('studentEnrollment.odd')
                          }}</option>
                          <option value="2">{{
                            $t('studentEnrollment.even')
                          }}</option>
                        </select>
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          class="text-danger"
                          @click="removeStudent(index, list)"
                          ><i class="fa fa-trash"></i
                        ></a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </panel>
          </div>
        </fieldset>
      </form>
    </ts-loading-banner>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'studentListEnrollment',
  props: ['value'],
  data() {
    return {
      model: {},
      student_search_value: '',
      student_search: false,
      studentResources: [],
      studentEnrollments: []
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    studentLists: function() {
      return this.studentResources.filter(
        s =>
          !_.includes(
            this.model.student_id_list.map(stud => stud.student_id),
            s.student_id
          )
      )
    }
  },
  methods: {
    ...mapActions('studentEnrollment', ['getStudent']),
    fetStudentList(params) {
      this.student_search = true
      this.getStudent(params)
        .then(response => {
          this.studentResources = response.data
        })
        .finally(() => {
          this.student_search = false
        })
    },
    selectStudent(student) {
      this.model.student_id_list.push({
        student_id: student.student_id,
        is_main_class: true,
        swap_type_id: 0
      })
      this.studentEnrollments.push(student)
    },
    studentFilter(student) {
      return this.studentEnrollments.find(
        s => s.student_id == student.student_id
      )
    },
    removeStudent(index, student) {
      // Remove from student_id_list
      this.model.student_id_list.splice(index, 1);

      // Find and remove from studentEnrollments in a single operation
      const studentId = student.student_id;
      const enrollmentIndex = this.studentEnrollments.findIndex(
        s => s.student_id === studentId
      );

      if (enrollmentIndex !== -1) {
        this.studentEnrollments.splice(enrollmentIndex, 1);
      }
    }
  },
  watch: {
    'model.class_id': function() {
      this.studentResources = []
      this.studentEnrollments = []
      this.student_search_value = ''
    },
    student_search_value: debounce(function(value) {
      if (value) {
        this.fetStudentList({
          search: value,
          page: -1,
          not_in_enrollmented_class: this.model.class_id
        })
      } else {
        this.fetStudentList({
          perPage: 20,
          not_in_enrollmented_class: this.model.class_id
        })
      }
    }, 500)
  }
}
</script>

<style lang="css" scoped>
#enroll {
  height: 70vh;
}

#student-table-container {
  height: 40vh;
  overflow-y: scroll;
}

::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #f0f3f4;
}
::-webkit-scrollbar-thumb:hover {
  background: #dddedf;
}

#student-table > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 999;
  padding: 7px;
  border-bottom: none !important;
}

#student-table > tbody > tr > td {
  cursor: pointer;
}

.loading {
  background-color: #ffffff;
  background-image: url('http://loadinggif.com/images/image-selection/3.gif');
  background-size: 18px 18px;
  background-position-x: 99%;
  background-position-y: 50%;
  background-repeat: no-repeat;
}
.none-border {
  border: none
}
</style>
